"use client";

import { Suspense } from "react";

import { CategoryFilters as UICategoryFilters } from "@jti/ui/eva-components/CategoryFilters/CategoryFilters";

import type { CategoryFiltersProps } from "./CategoryFilters.inputs.builder";
import useHandleFilters from "./useHandleFilters";

export function CategoryFilters(props: CategoryFiltersProps) {
  return (
    <Suspense>
      <CategoryFiltersContent {...props} />
    </Suspense>
  );
}

function CategoryFiltersContent({ subcategoriesWithProductCount, isProductCountVisible }: CategoryFiltersProps) {
  const { handleChange, updatedSubcategories, discontinuedProductName } = useHandleFilters({
    subcategoriesWithProductCount,
  });

  if (!updatedSubcategories.length) return null;

  return (
    <UICategoryFilters
      subcategories={updatedSubcategories}
      isProductCountVisible={isProductCountVisible}
      handleChange={handleChange}
      discontinuedProductName={discontinuedProductName}
    />
  );
}
